import { colors2, mediaQuery } from "oolib";
import styled, { css } from "styled-components";

const { grey10 } = colors2

export const StyledOKFHeader = styled.div`
  position: relative;
  background: ${colors2.white};
  /* box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); */
  
  ${({ showBorderBottom }) => showBorderBottom && css`
    border-bottom: 1px solid ${grey10};
  `}
  
  &.-six-six- {
    .OKE-Header__notifications {
      .OKE-Header__notificationsList {
        top: 6rem !important;
      }
    }
  }
`;

export const StyledOKFHeader1 = styled.div`

`;

export const StyledHeaderContent = styled.div`
  padding: 0 2rem;
  height: 100%;
  display: flex;
  justify-content: space-between;
  gap: 0.6rem;

  ${( { isSmallScreen }) => isSmallScreen && css`
    padding: 0 1rem;
  `}
`;

export const StyledHeaderNavLinksWrapper = styled.div`
  display: flex;
  align-items: center;
  height: 3.6rem;
  gap: 0.4rem;
`;
export const StyledHeaderLeft = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  
  ${({ isSmallScreen }) => isSmallScreen && css`
    gap: 1.2rem;
    flex-grow: 1;
  `}
  
`;
export const StyledHeaderRight = styled.div`
  display: flex;
  align-items: center;
  gap: 0.4rem;
`;

export const StyledHamburgerButton = styled.button`
  display: flex;
  align-items: center;
  flex-grow: 1;
  gap: 0.4rem;
  padding: 1.2rem 1.2rem;
  cursor: pointer;
  
  border-radius: 4.5rem;;
  border : 1px solid ${colors2.grey10};
  
  background-color: white;
  &:hover {
    background-color: ${colors2.grey5};
  }
`;

export const StyledHeaderLogo = styled.div`
  height: 4rem;
  display: flex;
  align-items: center;
`;

export const StyledHeaderLogoImage = styled.img`
  height: 100%;
`;

export const StyledHeader = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  gap: 0.4rem;
`;

export const StyledDropdownRefWrapper = styled.div`
  height: 100%;
  
  .OKE-Dropdown__Select {
    min-width: unset;
  }
`;

export const StyledSecondaryLink = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  background-color: transparent;
  transition: background-color 0.3s ease;
  cursor: pointer;
  
  &:hover {
    background-color: ${colors2.grey5};
  }
  
  &.active {
    background-color: ${colors2.grey5};
  }
`;

export const StyledSecondaryLinkInner = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
`;

export const StyledGlobalSearchLink = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  padding-left: 1rem;
  padding-right: 1rem;
  background-color: transparent;
  transition: background-color 0.3s ease;
  cursor: pointer;
  
  &:hover {
    background-color: ${colors2.grey5};
  }
  
  @media (min-width: 576px) {
    padding-left: 1rem;
    padding-right: 1.5rem;
  }
`;

export const StyledPublishButton = styled.button`
  background-color: ${colors2.grey100};
  border-radius: 2px;
  height: 4rem;
  display: flex;
  align-items: center;
  padding-left: 2rem;
  padding-right: 2rem;
  color: white;
  transition: background-color 0.3s ease;
  border: 0;
  cursor: pointer;
  
  &:hover {
    background-color: black;
  }
`;

export const StyledNotifications = styled.div`
  height: 100%;
  position: relative;
`;

export const StyledNotificationsButton = styled.button`
  border: none;
  background-color: white;
  padding-left: 1rem;
  padding-right: 1rem;
  height: 100%;
  transition: background-color 0.3s ease;
  cursor: pointer;
  
  &:hover {
    background-color: ${colors2.grey5};
  }
  
  @media (min-width: 576px) {
    padding-left: 2rem;
  }
`;

export const StyledNotificationsList = styled.div`
  position: absolute;
  right: 0;
  top: 10rem;
  z-index: 1;
`;

export const StyledMyAccountMenuButton = styled.button`
  border: none;
  background-color: white;
  padding-left: 1rem;
  padding-right: 2rem;
  height: 4.6rem;
  transition: background-color 0.3s ease;
  cursor: pointer;
  
  &:hover {
    background-color: ${colors2.grey5};
  }
`;

export const StyledLoginLink = styled.div`
  padding-left: 2rem;
  padding-right: 2rem;
`;

export const StyledOKFHeader2 = styled.div`
  height: 4rem;
  display: flex;
  justify-content: center;
  border-top: 1px solid ${colors2.grey10};
`;

export const StyledHeader2PrimaryLinksWrapper = styled.div`
  height: 100%;
  display: flex;
  justify-content: center;
`;

export const StyledPrimaryLink = styled.div`
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  background-color: transparent;
  transition: background-color 0.3s ease;
  
  &:hover {
    background-color: var(--primaryColor10);
  }
  
  &.active {
    background-color: var(--primaryColor10);
  }
`;

export const StyledPrimaryLinkInner = styled.div`
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  height: 100%;
  display: flex;
  align-items: center;
`;

export const StyledPrimaryLinksKebabMenu = styled.div`
  .OKE-Dropdown__ref-wrapper {
    height: 100%;
  }
`;

export const StyledKebabMenuSelectWrapper = styled.div`
  padding-left: 1rem;
  padding-right: 1rem;
  cursor: pointer;
  background-color: transparent;
  transition: background-color 0.3s ease;
  display: flex;
  align-items: center;
  height: 100%;
  
  &:hover {
    background-color: ${colors2.primaryContainer};
  }
`;

export const StyledKebabMenuOptionText = styled.div`
  color: ${colors2.onPrimary};
`;